// Small black identification card shown when an operator clicks "Ping" in
// the dashboard. Renders for ~5s (timer lives in usePlayerState) so an
// operator standing in front of a wall of TVs can match a row in the
// dashboard to a physical display.

interface Props {
  name: string
}

export default function PingOverlay({ name }: Props) {
  return (
    <div className="pointer-events-none absolute inset-x-0 top-8 z-30 flex justify-center">
      <div className="rounded-2xl bg-black/85 backdrop-blur px-6 py-4 shadow-2xl ring-1 ring-white/10">
        <div className="text-[11px] uppercase tracking-[3px] text-white/55 font-medium">
          Screen
        </div>
        {/* Identify by name only — never the internal id number. */}
        <div className="mt-0.5 text-3xl font-black text-white max-w-xs truncate">
          {name}
        </div>
      </div>
    </div>
  )
}
